export const Scroll = () => {
  window.scroll({
    top: 0,
    // left: 100,
    behavior: "smooth",
  });
  // window.document.getElementById("inputName").focus();
  // console.log("hi");
};

export const ScrollToposition = (screen) => {
  // if (screen) {
  //   window.scroll({
  //     top: 1400,
  //     left: 0,
  //     behavior: "smooth",
  //   });
  // }

  screen
    ? window.scroll({
        top: 3200,
        left: 0,
        behavior: "smooth",
      })
    : window.scroll({
        top: 2550,
        left: 0,
        behavior: "smooth",
      });

  console.log(screen);
};
